import React, { memo } from 'react';
import { useGoogleComponent } from './useGoogleComponent';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { Skeleton } from '../Skeleton/Skeleton';

interface GoogleComponentProps {
    classes?: string;
    lat: number;
    lng: number;
    onCoordinates?: (value: { latitude: number; longitude: number }) => void;
    mapCenter: { lat: number; lng: number };
}

export const GoogleComponent = memo(
    ({ lng, lat, onCoordinates, mapCenter }: GoogleComponentProps) => {
        const { containerStyle, marker, handleMarkerDragEnd, onLoad, isLoaded, onUnmount } =
            useGoogleComponent(lat, lng, onCoordinates);
        return (
            <>
                {isLoaded ? (
                    <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={mapCenter}
                        zoom={15}
                        onLoad={onLoad}
                        onUnmount={onUnmount}
                    >
                        <Marker
                            position={marker}
                            draggable={true}
                            onDragEnd={handleMarkerDragEnd}
                        />
                    </GoogleMap>
                ) : (
                    <Skeleton />
                )}
            </>
        );
    }
);
